import * as React from "react";
import { cn } from "../util";

/* Tabla editorial: hairlines, sin zebra, cabecera en versalitas Blinker. */
export function Tabla({ className, ...props }: React.HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="relative w-full overflow-x-auto border-y border-linea">
      <table className={cn("w-full caption-bottom font-ui text-sm", className)} {...props} />
    </div>
  );
}
export function TablaCabecera(props: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className="[&_tr]:border-b [&_tr]:border-linea-fuerte" {...props} />;
}
export function TablaCuerpo(props: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody className="[&_tr:last-child]:border-0" {...props} />;
}
export function TablaFila({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn(
        "border-b border-linea transition-colors hover:bg-fondo-suave data-[state=selected]:bg-fondo-alzado",
        className,
      )}
      {...props}
    />
  );
}
export function TablaEncabezado({
  className,
  ...props
}: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cn(
        "h-10 px-3 text-left align-middle text-xs font-semibold uppercase tracking-wide text-tinta-tenue",
        className,
      )}
      {...props}
    />
  );
}
export function TablaCelda({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cn("px-3 py-2.5 align-middle text-tinta", className)} {...props} />;
}
export function TablaPie({ className, ...props }: React.HTMLAttributes<HTMLTableCaptionElement>) {
  return <caption className={cn("mt-3 text-xs text-tinta-tenue", className)} {...props} />;
}
